import axios from "axios";
import API from "../api";

export const MenusModule = {
  state: {
    menus: [],
    isRequesting: false,
    errored: false,
    error: ""
  },
  actions: {
    getMenus({
      commit
    }) {
      return new Promise(async (resolve, reject) => {
        commit("getMenusRequest");
        return axios
          .get(`${API.BASE_URL}${API.MENUS}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("getMenusSuccess", response.data);
              // return response.data.original
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("menuError", error);
            reject(error);
          });
      });
    },
    createMenu({
      commit
    }, menuData) {
      return new Promise(async (resolve, reject) => {
        commit("createMenuRequest");
        return axios
          .post(`${API.BASE_URL}${API.MENUS}`, menuData, API.RequestHeaders())
          .then(response => {
            if (response.status === 201) {
              commit("createMenuSuccess", response.data.original);
              // return response.data.original
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("menuError", error);
            reject(error);
          });
      });
    },
    updateMenu({
      commit
    }, menuData) {
      return new Promise(async (resolve, reject) => {
        const menuId = menuData.id;
        delete menuData.id;
        commit("updateMenuRequest");
        return axios
          .put(`${API.BASE_URL}${API.MENUS}/${menuId}`, menuData, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("updateMenuSuccess", response.data.original);
              // return response.data.original
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("menuError", error);
            reject(error);
          });
      });
    },
    deleteMenu({
      commit
    }, menu) {
      return new Promise(async (resolve, reject) => {
        commit("deleteMenuRequest");
        return axios
          .delete(`${API.BASE_URL}${API.MENUS}/${menu}`, API.RequestHeaders())
          .then(response => {
            if (response.status === 200) {
              commit("deleteMenuSuccess", menu);
              resolve(response.data.original);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            commit("menuError", error);
            reject(error);
          });
      });
    }
  },
  mutations: {
    getMenusRequest(state) {
      state.isRequesting = true;
    },
    getMenusSuccess(state, payload) {
      state.menus = payload;
      state.isRequesting = false;
    },
    createMenuRequest(state) {
      state.isRequesting = true;
    },
    createMenuSuccess(state, payload) {
      state.menus.push(payload);
      state.isRequesting = false;
    },
    editMenu(state, menu){
      // state.menus = Object.assign({}, state.menus, menu);
      const index = state.menus.map(menu => menu.id).indexOf(payload.id);
      state.menus[index] = {
        ...state.menus[index],
        ...payload
      };
    },
    menuError(state, error) {
      state.isRequesting = false;
      state.errored = true;
      state.error = error.message;
    },
    updateMenuRequest(state) {
      state.isRequesting = true;
    },
    updateMenuSuccess(state, payload) {
      const index = state.menus.map(menu => menu.id).indexOf(payload.id);
      state.menus[index] = {
        ...state.menus[index],
        ...payload
      };
      state.isRequesting = false;
    },
    deleteMenuRequest(state) {
      state.isRequesting = false;
    },
    deleteMenuSuccess(state, _menu) {
      const deletedMenu = state.menus.find(
        menu => menu.id === _menu
      );
      const currentIndex = state.menus.indexOf(deletedMenu);
      state.menus.splice(currentIndex, 1);
      state.isRequesting = false;
    }
  },
  getters: {
    getAvailableMenus(state) {
      return state.menus;
    }
  }
};